export const CustomErrorMessages = [{
        serverMessage: 'Error Insert data not valid instance of application model',
        customMessage: 'Insert failed'
    }, {
        serverMessage: 'Error occured Deleting the record 30] Entry Not Found [0]',
        customMessage: 'This record is linked to other records. It cannot be deleted.'
    }, {
        serverMessage: 'No access [1]',
        customMessage: 'Your session has expired or is invalid. Please login again.'
}];
